// Create the component factory
mod.filters = mod.factory.create(mod.baseModule);

// ----------------------------------------------------------------------------
// Base
// ----------------------------------------------------------------------------

mod.filters.define("Base", function(fn) {

	fn.prototype.init = function(params) {
		this.screenerNamespace = params.screenerNamespace;

		// Init all the components that have a controller class
		this.initComponents();

		if (params.argument) {
			this.digestArgument(params.argument);
		}
	};

	// Initialize all the components that require controlling js classes
	fn.prototype.initComponents = function() {
		var $filters = this.$el.find("div.screener-component");
		$filters.each(function (i, component) {
			var success = component.getAttribute("data-success");

			if (success === "true") {
				var $component = $(component);
				var initFn = $component.attr("data-initfn");

				if (initFn) {
					// Save off the controller on the dom node
					$component.data("controller", mod.components.create(initFn, $component));
				}
			}
		});

	};

	fn.prototype.setComponentValue = function($component, values, fromSaved) {
		if ($component.attr("data-success") === "true") {
			this.getComponentController($component).setValue(values, fromSaved);
		}
	};

	fn.prototype.getComponentController = function(component) {
		return $(component).data("controller");
	};

	// There should only be 1 argument per filter
	// Arguments may have many clauses however
	fn.prototype.getArgument = function () {
		var argument = new this.screenerNamespace.Argument();
		var field = this.getArgumentSafeName();
		var operator = this.getArgumentOperators();
		var values = this.getArgumentValues();
		var clauses = this.getArgumentClauses();
		var identifiers = this.getArgumentIdentifiers();
		// Add the safe name
		if (field) {
			argument.SetField(field);
			argument.SetSafeName(field);
		}

		// Arguments with "NOTLIKE" need to be linked with "AND"
		if (operator === 'NotLike' && values && values.length) {
			argument.SetValueOperator(0);
		}

		// Add single operator and values
		if (operator && values) {
			for (var i = 0; i < values.length; i++) {
				var value = values[i];

				argument.AddClause(
					new this.screenerNamespace.Argument.Clause(
						this.screenerNamespace.OPERATORS[operator],
						[value]
					)
				);
			}
		}

		// Set the identitiers whether we have any or not (to wipe out removed ones)
		argument.SetIdentifiers(identifiers);

		// Add clauses
		if (clauses) {
			for (var i = 0; i < clauses.length; i++) {
				var clause = clauses[i];

				argument.AddClause(
					new this.screenerNamespace.Argument.Clause(
						this.screenerNamespace.OPERATORS[clause.operator],
						[clause.value]
					)
				);
			}
		}

		return argument;
	};

	fn.prototype.getArgumentSafeName = function () {

	    //debugger;

		// Try to get a fixed safeName from the filter itself
		var safeName = this.$el.attr("data-safename") || "";
		var nameParts = [];
		//var $namers = this.$el.find("[data-role-safename]:visible");
		var $namers = this.$el.find("[data-role-safename]");

		for (var i = 0; i < $namers.length; i++) {
			var $namer = $namers.eq(i);

			// Get the js class that handles this component
			var namerClass = this.getComponentController($namer);
			var namePart = namerClass.getValue();

			// Sometimes, only a couple of the options will have safe name parts
			// We should allow those parts to skip this concatenation
			if (namePart) {
				nameParts.push(namePart);
			}
		}

		if (nameParts.length) {
			safeName += nameParts.join("");
		}

		if (!safeName) {
			alert("No safe name!");
		}

		return safeName;
	};

	fn.prototype.getArgumentOperators = function() {
		// Do we have a fixed safe name on the filter?
		var operator = this.$el.attr("data-operator");

		//The if condition is for ticker list filter as this filter works on inputs by user as opossed to other filters which populate arguments from screener qid.
		if (this.$el.attr("data-safename") == "WSODIssueID") {
			return "Equals";
		}

		// Look for controls that dynamically change the field
		if (!operator) {
			var $operatorSwitchers = this.$el.find("[data-role-operator]:visible");

			if ($operatorSwitchers.length) {
				// Get the value from the control
				var $switcher = $operatorSwitchers.eq(0);
				var valuerClass = this.getComponentController($switcher);
				operator = valuerClass.getValue();
			}
		}

		return operator;
	};

	fn.prototype.getArgumentValues = function() {
		var values = [];
		var $valuer = this.$el.find("[data-role-value]:visible").first();
		var safeName = this.$el.attr("data-safename");

		//The if condition is for ticker list filter as this filter works on inputs by user as opossed to other filters which populate arguments from screener qid.
		if (safeName == "WSODIssueID") {
			var wsodIssues = this.$el.find('[data-wsodissue]').attr('data-wsodissue');
			if (wsodIssues) {
				//get issues and scrub them
				var aryRawIssues = wsodIssues.split(",");
				var aryIssues = [];
				for (var i = 0, j = aryRawIssues.length; i < j; i++) {
					var currItem = aryRawIssues[i].replace(/^\D/, "");
					if (currItem.length > 0) {
						aryIssues.push(currItem);
					}
				}
				return aryIssues;
			} else {
				// on intitial load return a default non existing wsod issue Id
				return ["0000"];
			}
		} else if (safeName == "ShowAvailable") { 
			var val = this.$el.data("role-value");
			values = val;
		}

		if ($valuer.length) {
			var valuerClass = this.getComponentController($valuer);
			values = valuerClass.getValue();

			// Always make "value" an array
			if (values instanceof Array == false) {
				values = [values];
			}
		}

		return values;
	};

	fn.prototype.getArgumentClauses = function() {
		var clauses = [];
		var $components = this.$el.find("[data-role-clause]:visible");

		if (this.$el.attr("data-safename") != "WSODIssueID") {
			for (var i = 0; i < $components.length; i++) {
				var $component = $components.eq(i);

				if ($component.attr("data-success") === "true") {
					var componentClass = this.getComponentController($component);
					var componentClauses = componentClass.getValue();

					// Make sure it's an array
					if (componentClauses instanceof Array == false) {
						componentClauses = [componentClauses];
					}

					// Add all the clauses
					for (var x = 0; x < componentClauses.length; x++) {
						var clause = componentClauses[x];
						if (clause) {
							clauses.push(clause);
						}
					}
				}
			}
		}

		return clauses;
	};

	fn.prototype.getArgumentIdentifiers = function() {
		var identifiers = [];

		var $keyComponent = this.$el.find("[data-role-identifierkey]:visible").first();
		var $valComponent = this.$el.find("[data-role-identifiervalue]:visible").first();

		// Must have a key and a value
		if ($keyComponent.length || $valComponent.length) {
			var keyComponentClass = this.getComponentController($keyComponent);
			var valComponentClass = this.getComponentController($valComponent);
			var key, value;

			if (keyComponentClass) {
				key = keyComponentClass.getIdentifier();
			}

			if (valComponentClass) {
				value = valComponentClass.getIdentifier();
			}

			if (key && value) {
				// Smash the parts together
				identifiers.push(key + '|' + value);
			}
		}

		return identifiers;
	};

	fn.prototype.digestArgument = function(argument) {
		throw 'Not implemented';
	};

	fn.prototype.events = {
		".removeCriterion": {
			"click": function(e, $el) {
				this.$el.remove();

				// Tell the screener that we removed this filter
				mod.observer.trigger("screener - remove filter", this.$el);
			}
		}
	};

});

// ----------------------------------------------------------------------------
// Utility
// ----------------------------------------------------------------------------

// Set a multiple values on a [data-role-clause]
function setMinMaxFromArg(arg, fromSaved) {
	var minValue, maxValue;

	if (arg.Clauses && arg.Clauses.length) {
		if (arg.Clauses[0].Operator.indexOf('GreaterThan') === 0) {
			minValue = arg.Clauses[0].Values[0];

			if (arg.Clauses.length > 1) {
				maxValue = arg.Clauses[1].Values[0];
			}
		}
		else {
			maxValue = arg.Clauses[0].Values[0];

			if (arg.Clauses.length > 1) {
				minValue = arg.Clauses[1].Values[0];
			}
		}
	}

	// Find the right component and let it set values
	var $component = this.el.find('div[data-role-clause]:visible');
	this.setComponentValue($component, [minValue, maxValue], fromSaved);
}

// Set a multiple values on a [data-role-value]
function setValuesSimple(arg) {
	var values = $.map(arg.Clauses, function(clause) {
		return clause.Values[0];
	});

	// Find the right component and let it set values
	var $component = this.el.find('div[data-role-value]');
	this.setComponentValue($component, values);
}

// Set a single value on a [data-role-value]
function setValueSimple(arg) {
	var value = '';

	if (arg.Clauses && arg.Clauses.length && arg.Clauses[0].Values.length) {
		value = arg.Clauses[0].Values[0];
	}

	var $component = this.el.find('div[data-role-value]');
	this.setComponentValue($component, value);
}

// ----------------------------------------------------------------------------
// Specific
// ----------------------------------------------------------------------------

mod.filters.define("IsIsNotFilter", "Base", function(fn) {

	fn.prototype.digestArgument = function (arg) {
		if (arg.Clauses && arg.Clauses.length === 0) {
			arg.Clauses = [
				{
					"Operator": "Like",
					"Values": [
						"-32768"
					]
				}
			]
        }
		var op = arg.Clauses[0].Operator;
		var values = $.map(arg.Clauses, function(clause) {
			return clause.Values;
		});
		var isMulti = values.length > 1;	

		// --------------------
		// Set operator
		// --------------------

		// Loop over all the options till we find the one we want
		// We can't just set the value, because multiple options share the same value
		this.el.find('div.screener-component[data-role-operator] select').find('option').each(function(i, option) {
			if (option.value === op) {
				if (!isMulti || (isMulti && option.getAttribute('data-ismulti') === 'true')) {
					option.selected = true;
					return false;
				}
			}
		}).change();

		// --------------------
		// Set value
		// --------------------

		// Find the right component and let it set values
		var $component = this.el.find('div.screener-component[data-role-value][data-ismulti=' + isMulti + ']');
		this.setComponentValue($component, values);
	};

});

mod.filters.define("IsSymbolsFilter", "Base", function (fn) {

	fn.prototype.digestArgument = function (arg) {

	};

});

mod.filters.define("ButtonGroupFilter", "Base", function(fn) {

	fn.prototype.digestArgument = setValuesSimple;

});

mod.filters.define("FinancialStrengthFilter", "Base", function(fn) {

	fn.prototype.digestArgument = setValuesSimple;

});

mod.filters.define("PercentileFilter", "Base", function(fn) {

	fn.prototype.digestArgument = function(arg) {
		// --------------------
		// Set operator
		// --------------------

		var opOptionValue;
		var $opSelect = this.el.find('div[data-role-safename] select');

		$opSelect.find('option').each(function(i, option) {
			if (option.value && arg.Field.indexOf(option.value) !== -1) {
				opOptionValue = option.value;
				return false;
			}
		});

		$opSelect.val(opOptionValue).change();

		// --------------------
		// Set value
		// --------------------

		setMinMaxFromArg.call(this, arg);
	};

});

mod.filters.define("HistogramFilter", "Base", function(fn) {

	fn.prototype.digestArgument = setMinMaxFromArg;

});

mod.filters.define("SliderFilter", "Base", function(fn) {

	fn.prototype.digestArgument = setMinMaxFromArg;

});

mod.filters.define("DateFilter", "Base", function(fn) {

	fn.prototype.digestArgument = function(arg) {
		// Try to ignore the clauses and look at the identifiers instead
		if (arg.Identifiers && arg.Identifiers.length) {
			var parts = arg.Identifiers[0].split('|');
			var key = parts[0];
			var value = parts[1];

			// Set operator
			var $opComponent = this.el.find('div[data-role-identifierkey]');
			this.setComponentValue($opComponent, key);

			// Set value
			var $valComponent = this.el.find('div[data-role-identifiervalue]');
			this.setComponentValue($valComponent, value);
		}
		else {
			// --------------------
			// Set operator
			// --------------------

			var $opSelect = this.el.find('div[data-role-operator] select');
			$opSelect.val('').change();

			// --------------------
			// Set value
			// --------------------

			setMinMaxFromArg.call(this, arg);
		}
	};

});

mod.filters.define("DropDownFilter", "Base", function(fn) {

	fn.prototype.digestArgument = setValueSimple;

});

mod.filters.define("YesNoFilter", "Base", function(fn) {

	fn.prototype.digestArgument = setValueSimple;

});

mod.filters.define("TextRangeFilter", "Base", function(fn) {

	fn.prototype.digestArgument = setMinMaxFromArg;

});

mod.filters.define("Text", "Base", function (fn) {
});


mod.filters.define("ShowAvailableFilter", "Base", function (fn) {

	fn.prototype.init = function (params) {
		this.base("init", params);
		this.$switch = $('div.switch', this.$el);

		if (params.argument && params.argument == true) {
			this.$switch.addClass("icon-switch-on").removeClass("icon-switch-off");
			this.$el.data("role-value", params.argument ? "1" : "0");

			// The correct button will be selected by the time we build inputs for the screener call
			setTimeout(function () {
				mod.observer.trigger("screener - showAvailableFilter", { resetPaging: true });
			}, 0);
		}
	};

	fn.prototype.digestArgument = function () { };

	fn.prototype.events = {
		".switch": {
			"click": function (e, $el) {
				var val = 0;
				if (this.$switch.hasClass("icon-switch-on")) {
					this.$switch.removeClass("icon-switch-on").addClass("icon-switch-off");
					val = 0;
				} else {
					this.$switch.addClass("icon-switch-on").removeClass("icon-switch-off");
					val = 1;
				}

				this.$el.data("role-value", val.toString());

				// Kick the handler into the event queue so the normal button behavior will run first
				// The correct button will be selected by the time we build inputs for the screener call
				setTimeout(function () {
					mod.observer.trigger("screener - showAvailableFilter", { resetPaging: true });
				}, 0);
			}
		}
	};
});

mod.filters.define("ActualEstimateProjectedFilter", "Base", function(fn) {

	fn.prototype.digestArgument = function(arg) {
		// Figure out what control we're dealing with
		var $clauseControl = this.el.find('div[data-role-clause]');
		var controlType = $clauseControl.attr('data-initfn');

		// Find the safe name controls
		var $opSelect = this.el.find('div[data-role-safename] select');

		if (controlType === 'TextRange') {
			// Set operator
			$opSelect.val(arg.Field).change();
		}
		else if (controlType === 'BucketSlider' || controlType === 'HistogramSlider') {
			// Make a local copy of the field so we can mutate it
			var field = arg.Field;

			var $prefixOpSelect = $opSelect.eq(0);
			var $suffixOpSelect = $opSelect.eq(1);
			var prefixValue = '';
			var suffixValue = '';

			// --------------------
			// Set operator suffix
			// --------------------

			$suffixOpSelect.find('option').each(function(i, option) {
				if (option.value && field.indexOf(option.value) !== -1) {
					suffixValue = option.value;

					// Remove the matched part so we can more easily match the prefix
					field = field.replace(option.value, '');

					return false;
				}
			});
			$suffixOpSelect.val(suffixValue).change();

			// --------------------
			// Set operator prefix
			// --------------------

			// Set the prefix now that we know the exact value we're looking for
			$prefixOpSelect.find('option').each(function(i, option) {
				if (option.value === field) {
					prefixValue = option.value;
					return false;
				}
			});
			$prefixOpSelect.val(prefixValue).change();
		}

		// --------------------
		// Set values
		// --------------------

		var fromSaved = true;

		setMinMaxFromArg.call(this, arg, fromSaved);

		// VL-260 This is to clear out the saved values after all the saved screen reloads & screens are copmlete (otherwise, the saved values get stuck.)
		$(document).ajaxStop(function () {
			$clauseControl.find("input[data-saved]").each(function () { this.setAttribute("data-saved", ""); });
		});
	};

});

mod.filters.define("AnnualizedCumulativeFilter", "Base", function(fn) {

	fn.prototype.digestArgument = function(arg) {
		// --------------------
		// Set operator
		// --------------------

		var opOptionValue;
		var $opSelect = this.el.find('div[data-role-safename] select');

		$opSelect.find('option').each(function(i, option) {
			if (option.value && arg.Field.indexOf(option.value) !== -1) {
				opOptionValue = option.value;
				return false;
			}
		});

		$opSelect.val(opOptionValue).change();

		// --------------------
		// Set value
		// --------------------

		setMinMaxFromArg.call(this, arg);
	};

});